// extracted by mini-css-extract-plugin
export default {"pricingList":"wb","pricingFootnote":"xb","switchWrapper":"yb","faqWrapper":"zb","blinking":"Ab","gradientShift":"Bb","float":"Cb","move":"Db","scroll":"Eb"};